<template>
    <Head :title="course?.title || 'Course'" />
    <div class="px-4 md:px-8">
        <CourseComponent />
    </div>
</template>
<script setup>
import { Head } from '@inertiajs/vue3';
import CourseComponent from '@/components/courses/course.vue';
import { useCoursesStore } from '@/store/courses';
import { storeToRefs } from 'pinia';

const store = useCoursesStore();
const { course } = storeToRefs(store);
</script>
